/**
 * Convenience inspection utilities
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
function isArray(value) {
  return Array.isArray(value);
} // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any

function isUndefined(value) {
  return value === undefined;
}

export { isArray, isUndefined };
